<template>
  <ion-menu side="start" content-id="content">
    <ion-header>
      <ion-toolbar>
        <ion-title>Menu</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-list>
        <ion-item
          @click="navigate('App: Location Menu')"
          button="true"
          data-cy="menu-item-location-menu"
        >
          <ion-icon name="restaurant" slot="start"></ion-icon>
          <ion-label>Place an Order</ion-label>
        </ion-item>
        <ion-item
          v-if="user"
          @click="navigate('App: Order History')"
          button="true"
          data-cy="menu-item-order-history"
        >
          <ion-icon name="time" slot="start"></ion-icon>
          <ion-label>Order History</ion-label>
        </ion-item>
        <ion-item
          v-if="user"
          @click="navigate('App: Payment Methods')"
          button="true"
          data-cy="menu-item-payment-methods"
        >
          <ion-icon name="card" slot="start"></ion-icon>
          <ion-label>Payment Methods</ion-label>
        </ion-item>
        <ion-item
          @click="navigate('App: Locations')"
          button="true"
          data-cy="menu-item-locations"
        >
          <ion-icon name="compass" slot="start"></ion-icon>
          <ion-label>Choose Different Location</ion-label>
        </ion-item>
        <ion-item
          v-if="user"
          @click="navigate('Account Settings')"
          button="true"
          data-cy="menu-item-account-settings"
        >
          <ion-icon name="person" slot="start"></ion-icon>
          <ion-label>Account Settings</ion-label>
        </ion-item>
        <ion-item
          @click="navigate('Support and Contact')"
          button="true"
          data-cy="menu-item-support-and-contact"
        >
          <ion-icon name="help-buoy" slot="start"></ion-icon>
          <ion-label>Support and Contact</ion-label>
        </ion-item>
        <ion-item v-if="hasLabMenu" @click="navigate('Lab')" button="true">
          <ion-icon name="planet" slot="start"></ion-icon>
          <ion-label>Lab</ion-label>
        </ion-item>
      </ion-list>
    </ion-content>
  </ion-menu>
</template>

<script>
import SideMenuBase from "@/components/Shared/SideMenuBase";
import { mapGetters } from "vuex";

export default {
  extends: SideMenuBase,

  computed: {
    ...mapGetters("auth", ["user"])
  }
};
</script>
